var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { IS_SHIPPING_ADDRESS } from "../Constant";
//get Country,State Data
import { getStates } from "country-state-picker";
import { SharedFunctions } from "../SharedFunctions";
export function CommonMethods() {
    var _a = SharedFunctions(), filterprovince = _a.filterprovince, getProvinceOfShopify = _a.getProvinceOfShopify, getCountriesList = _a.getCountriesList, getZoneCode = _a.getZoneCode;
    var getDefaultAddress = function () { return ({
        firstName: "",
        lastName: "",
        address1: "",
        address2: "",
        country: "",
        province: "",
        city: "",
        zipNumber: "",
        companyName: "",
        mobileNumber: "",
        countryCode: "",
        countriesStateData: [],
    }); };
    // 🔹 Company Location Default
    var getDefaultCompanyLocation = function () { return ({
        Id: "",
        Name: "",
        Note: "",
        ExternalId: "",
        ContactPersons: [],
        Catalogs: [],
        ShippingAddress: getDefaultAddress(),
        BillingAddress: getDefaultAddress(),
        PaymentTermsTemplateId: "",
        TaxExempt: false,
        TaxRegistrationId: "",
        BuyerExperienceConfiguration: getDefaultPaymentTerms(),
        BillingSameAsShipping: true,
    }); };
    var getDefaultPaymentTerms = function () { return ({
        PaymentTermsId: "",
        PaymentTermsName: "",
    }); };
    // defaults.ts
    var defaults = {
        address: {
            firstName: "",
            lastName: "",
            address1: "",
            address2: "",
            country: "",
            province: "",
            city: "",
            zipNumber: "",
            companyName: "",
            mobileNumber: "",
            countryCode: "",
            countriesStateData: [],
        },
        companyCatalog: {
            Id: "",
            Title: "",
            ProductCount: 0,
        },
        ContactPersons: {
            Id: "",
            DisplayName: "",
            Email: "",
            Role: "",
        },
        companyContact: {
            Id: "",
            FirstName: "",
            LastName: "",
            DisplayName: "",
            Email: "",
            Role: "",
            IsMainContact: false,
        },
        companyLocation: {
            Id: "",
            Name: "",
            Note: "",
            ExternalId: "",
            ContactPersons: [],
            Catalogs: [],
            ShippingAddress: null,
            BillingAddress: null,
            PaymentTermsTemplateId: null,
            TaxExempt: false,
            TaxRegistrationId: null,
            BuyerExperienceConfiguration: null,
        },
        taxSettings: {
            TaxExemptions: [],
            TaxRegistrationId: null,
        },
        companyDetails: {
            Id: "",
            Name: "",
            ExternalId: "",
            Note: "",
            MainContact: null,
            TaxSettings: {},
            Contacts: [],
            Locations: [],
            ContactRoles: [],
        },
    };
    var initialFormData = {
        company: "",
        companyId: "",
        taxId: "",
        mainContact: "",
        mainContactId: "",
        mainContactEmail: "",
        billingSameAsShipping: true,
        locationId: "",
        catalog: [],
        paymentTerms: "",
        taxIdField: "",
        taxSettings: "",
        companyNote: "",
        // ✅ Common Address Structure
        ShippingAddress: {
            firstName: "",
            lastName: "",
            address1: "",
            address2: "",
            city: "",
            zipNumber: "",
            companyName: "",
            mobileNumber: "",
            country: "",
            province: "",
            countryCode: "",
            countriesStateData: [],
        },
        BillingAddress: {
            firstName: "",
            lastName: "",
            address1: "",
            address2: "",
            city: "",
            zipNumber: "",
            companyName: "",
            mobileNumber: "",
            country: "",
            province: "",
            countryCode: "",
            countriesStateData: [],
        },
    };
    var getDefaultCompanyDetails = function () { return (__assign(__assign({}, defaults.companyDetails), { TaxSettings: __assign({}, defaults === null || defaults === void 0 ? void 0 : defaults.taxSettings), Contacts: [], Locations: [], ContactRoles: [] })); };
    var SearchByCountry = function (_a) {
        var _b;
        var value = _a.value, addressType = _a.addressType, setFormData = _a.setFormData;
        if (!value || !value.trim())
            return;
        var filteredByCountry = (_b = getCountriesList()) === null || _b === void 0 ? void 0 : _b.filter(function (country) { return country === null || country === void 0 ? void 0 : country.name.toLowerCase().includes(value.toLowerCase()); });
        var selectedCountry = filteredByCountry === null || filteredByCountry === void 0 ? void 0 : filteredByCountry[0];
        if (!selectedCountry)
            return;
        var selectedCountryName = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.name;
        var selectedCountryCode = selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.code;
        var provinceStatesFromShopify = getProvinceOfShopify(selectedCountryName || "");
        var fallbackStates = getStates(selectedCountryCode || "");
        var finalStateArray = (provinceStatesFromShopify === null || provinceStatesFromShopify === void 0 ? void 0 : provinceStatesFromShopify.length) ? provinceStatesFromShopify : fallbackStates;
        var filteredStates = filterprovince(finalStateArray !== null && finalStateArray !== void 0 ? finalStateArray : [], selectedCountryCode !== null && selectedCountryCode !== void 0 ? selectedCountryCode : "");
        var addressKey = addressType === IS_SHIPPING_ADDRESS ? "ShippingAddress" : "BillingAddress";
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[addressKey] = __assign(__assign({}, prev[addressKey]), { country: selectedCountryName, countryCode: selectedCountryCode, province: "", countriesStateData: filteredStates }), _a)));
        });
    };
    // Set country selected state array
    var resolveCountryStateData = function (country, provinceInput) {
        if (!(country === null || country === void 0 ? void 0 : country.trim())) {
            return {
                resolvedProvince: "",
                countriesStateData: [],
            };
        }
        var lowerCaseCountry = country === null || country === void 0 ? void 0 : country.toLowerCase();
        var countryList = getCountriesList() || [];
        var selectedCountry = countryList === null || countryList === void 0 ? void 0 : countryList.find(function (c) { return (c === null || c === void 0 ? void 0 : c.name.toLowerCase()) === lowerCaseCountry; });
        if (!selectedCountry) {
            return {
                resolvedProvince: "",
                countriesStateData: [],
            };
        }
        var selectedName = selectedCountry.name, selectedCode = selectedCountry.code;
        var provincesFromShopify = getProvinceOfShopify(selectedName) || [];
        var provincesFromFallback = getStates(selectedCode) || [];
        var stateArray = provincesFromShopify.length ? provincesFromShopify : provincesFromFallback;
        var filteredStates = filterprovince(stateArray, selectedCode);
        var resolvedProvince = provinceInput ? (filteredStates === null || filteredStates === void 0 ? void 0 : filteredStates.find(function (state) { return (state === null || state === void 0 ? void 0 : state.toLowerCase()) === (provinceInput === null || provinceInput === void 0 ? void 0 : provinceInput.toLowerCase()); })) || "" : "";
        return {
            resolvedProvince: resolvedProvince,
            countriesStateData: filteredStates,
        };
    };
    // To set selected countries states
    var mapAddress = function (address) {
        if (!address)
            return null;
        var country = (address === null || address === void 0 ? void 0 : address.Country) || "";
        var rawProvince = (address === null || address === void 0 ? void 0 : address.Province) || "";
        var _a = resolveCountryStateData(country, rawProvince), resolvedProvince = _a.resolvedProvince, countriesStateData = _a.countriesStateData;
        return {
            firstName: (address === null || address === void 0 ? void 0 : address.FirstName) || "",
            lastName: (address === null || address === void 0 ? void 0 : address.LastName) || "",
            address1: (address === null || address === void 0 ? void 0 : address.Address1) || "",
            address2: (address === null || address === void 0 ? void 0 : address.Address2) || "",
            city: (address === null || address === void 0 ? void 0 : address.City) || "",
            province: resolvedProvince,
            zipNumber: (address === null || address === void 0 ? void 0 : address.Zip) || "",
            country: country,
            countryCode: (address === null || address === void 0 ? void 0 : address.CountryCode) || "",
            companyName: (address === null || address === void 0 ? void 0 : address.CompanyName) || "",
            mobileNumber: (address === null || address === void 0 ? void 0 : address.Phone) || "",
            countriesStateData: countriesStateData,
        };
    };
    var mapAddressOfselectedCompanyInCreateOrder = function (address) {
        if (!address)
            return null;
        var country = (address === null || address === void 0 ? void 0 : address.country) || "";
        var rawProvince = (address === null || address === void 0 ? void 0 : address.province) || "";
        var _a = resolveCountryStateData(country, rawProvince), resolvedProvince = _a.resolvedProvince, countriesStateData = _a.countriesStateData;
        return {
            firstName: (address === null || address === void 0 ? void 0 : address.firstName) || "",
            lastName: (address === null || address === void 0 ? void 0 : address.lastName) || "",
            address1: (address === null || address === void 0 ? void 0 : address.address1) || "",
            address2: (address === null || address === void 0 ? void 0 : address.address2) || "",
            city: (address === null || address === void 0 ? void 0 : address.city) || "",
            province: resolvedProvince,
            zipNumber: (address === null || address === void 0 ? void 0 : address.zip) || "",
            country: country,
            countryCode: (address === null || address === void 0 ? void 0 : address.countryCode) || "",
            companyName: (address === null || address === void 0 ? void 0 : address.companyName) || "",
            mobileNumber: (address === null || address === void 0 ? void 0 : address.phone) || "",
            countriesStateData: countriesStateData,
        };
    };
    var renderAddress = function (addressInfo) {
        if ((addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.firstName) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.lastName) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address1) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address2) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.city) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.province) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.country) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.zipNumber) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.companyName) ||
            (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.mobileNumber)) {
            return (_jsxs(Typography, __assign({ variant: "body2", className: "ST_CommonTextFont_size" }, { children: [(addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.firstName) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.lastName) || "", " ", _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.companyName) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.companyName) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address1) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address1) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address2) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.address2) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.zipNumber) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.city) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.province) || "", " ", ((addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.zipNumber) || (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.city) || (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.province)) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.country) || "", " ", (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.country) && _jsx("br", {}), (addressInfo === null || addressInfo === void 0 ? void 0 : addressInfo.mobileNumber) || ""] })));
        }
        return (_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", className: "ST_CommonTextFont_size" }, { children: "No Address Found" })));
    };
    var getAddressPayload = function (Address) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (Address) {
            return {
                firstName: (_a = Address === null || Address === void 0 ? void 0 : Address.firstName) !== null && _a !== void 0 ? _a : "",
                lastName: (_b = Address === null || Address === void 0 ? void 0 : Address.lastName) !== null && _b !== void 0 ? _b : "",
                address1: (_c = Address === null || Address === void 0 ? void 0 : Address.address1) !== null && _c !== void 0 ? _c : "",
                address2: (_d = Address === null || Address === void 0 ? void 0 : Address.address2) !== null && _d !== void 0 ? _d : "",
                city: (_e = Address === null || Address === void 0 ? void 0 : Address.city) !== null && _e !== void 0 ? _e : "",
                zoneCode: getZoneCode((_f = Address === null || Address === void 0 ? void 0 : Address.countryCode) !== null && _f !== void 0 ? _f : "", (_g = Address === null || Address === void 0 ? void 0 : Address.province) !== null && _g !== void 0 ? _g : ""),
                zip: (_h = Address === null || Address === void 0 ? void 0 : Address.zipNumber) !== null && _h !== void 0 ? _h : "",
                phone: (_j = Address === null || Address === void 0 ? void 0 : Address.mobileNumber) !== null && _j !== void 0 ? _j : "",
                countryCode: (_l = (_k = Address === null || Address === void 0 ? void 0 : Address.countryCode) === null || _k === void 0 ? void 0 : _k.toUpperCase()) !== null && _l !== void 0 ? _l : "",
            };
        }
        else {
            {
            }
        }
    };
    var addressValidationCheckForShipping = function (addressData) {
        var shippingFields = ["firstName", "lastName", "address1", "country", "province", "city", "zipNumber"];
        return validateAddressFields(addressData, shippingFields);
    };
    var addressValidationCheckForBilling = function (addressData) {
        var billingFields = ["firstName", "lastName", "address1", "address2", "country", "province", "city", "zipNumber", "companyName", "mobileNumber"];
        return validateAddressFields(addressData, billingFields);
    };
    var validateAddressFields = function (addressData, requiredFields) {
        return requiredFields.some(function (field) { var _a, _b; return !!((_b = (_a = addressData[field]) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.trim()); });
    };
    return {
        SearchByCountry: SearchByCountry,
        getDefaultCompanyDetails: getDefaultCompanyDetails,
        getDefaultCompanyLocation: getDefaultCompanyLocation,
        resolveCountryStateData: resolveCountryStateData,
        mapAddress: mapAddress,
        mapAddressOfselectedCompanyInCreateOrder: mapAddressOfselectedCompanyInCreateOrder,
        renderAddress: renderAddress,
        initialFormData: initialFormData,
        getAddressPayload: getAddressPayload,
        addressValidationCheckForShipping: addressValidationCheckForShipping,
        addressValidationCheckForBilling: addressValidationCheckForBilling,
        getDefaultAddress: getDefaultAddress,
    };
}
